import { IconButton } from '@mui/material';
import Popper from '@shared/ui/Popper';
import { memo } from 'react';
import { Menu, MenuItem } from '@/component/Menu';
import { useDeleteConversation } from '@/feature/chatbot/useDeleteConversation';
import { useTexts } from '@/feature/lang';
import { Icon } from '@/icon/Icon';

export const ConversationMenu = memo(function ConversationMenu({
  conversationId,
}: {
  conversationId?: string;
}) {
  const texts = useTexts().component.chatbot.actions;
  const deleteConversation = useDeleteConversation();
  const enabled = Boolean(conversationId);

  return (
    <Popper
      Content={({ onClose }) => (
        <Menu onClose={onClose}>
          <MenuItem
            label={texts.deleteConversation}
            color={enabled ? 'error' : 'primary'}
            disabled={!enabled}
            onClick={() => deleteConversation(conversationId!)}
          />
        </Menu>
      )}
      Trigger={({ onClick }) => (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onClick(e);
          }}
          size="small"
        >
          <Icon name="more_vert" size="small" />
        </IconButton>
      )}
      placement="bottom-end"
    />
  );
});
